module.exports = __webpack_public_path__ + "img/swingLines1.0b863a4b.png";